export const CONFIG = {
    defaultLang: 'es',
    apiUrl: process.env.ANY_URL,
    getWsUrl: function (endpoint) {
        return process.env.ANY_URL + '/' + endpoint
    },
    localStorageDisk: process.env.ANY_DISK,
    appVersion: "1.1.9"
};
